// worldpantry-ipzipcode.js file 

(function () {
  // Configuration
  const PROXY_PATH = '/apps/ipzipcode'; // change to your app proxy path
  const COOKIE_NAME = 'zipcode';
  const COOKIE_DAYS = 7; // how long to keep the zipcode cookie

  // Cookie helpers
  function getCookie(name) {
    const re = new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)');
    const m = document.cookie.match(re);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function setCookie(name, value, days) {
    const expires = days ? '; expires=' + new Date(Date.now() + days * 864e5).toUTCString() : '';
    // Secure and SameSite recommended for production; HttpOnly cannot be set from JS
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; Secure; SameSite=Lax';
  }

  // Only proceed if cookie not present
  if (getCookie(COOKIE_NAME)) {
    // cookie exists — do nothing
    return;
  }

  // Optional: if your theme injects the visitor IP into a JS variable, include it
  // e.g. window.__VISITOR_IP__ = "{{ request.remote_ip }}" (set in Liquid)
  const visitorIp = window.__VISITOR_IP__ || null;

  // Build URL (do not compute signature client-side)
  const url = visitorIp ? `${PROXY_PATH}?ip=${encodeURIComponent(visitorIp)}` : PROXY_PATH;

  // Fetch the proxy (Shopify will append signature when request is proxied)
  fetch(url, { credentials: 'same-origin' })
    .then(response => {
      if (!response.ok) throw new Error('Network response not ok: ' + response.status);
      return response.json();
    })
    .then(data => {
      // Expecting { zip: "94105", cached: true/false } or { zip: null }
      if (data && data.zip) {
        setCookie(COOKIE_NAME, data.zip, COOKIE_DAYS);
      } else {
        // Optionally set a short negative cache to avoid repeated failing calls
        setCookie(COOKIE_NAME, '', 0.02); // ~30 minutes (0.02 days)
      }
    })
    .catch(err => {
      // Fail silently in production; optionally log to analytics
      console.error('ipzipcode fetch error', err);
    });
})();
